"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatManager = exports.chatClient = void 0;
const react_1 = __importDefault(require("react"));
const stream_chat_1 = require("stream-chat");
const stream_chat_react_1 = require("stream-chat-react");
const config_1 = require("@app/const/config");
const i18n_1 = require("@app/util/i18n");
const useConnectUser_1 = require("./useConnectUser");
const { location: { hostname }, } = window;
const { chatApiKey } = (0, config_1.getEndpoints)(hostname);
exports.chatClient = stream_chat_1.StreamChat.getInstance(chatApiKey);
const ChatManager = ({ children, }) => {
    (0, useConnectUser_1.useConnectUser)(exports.chatClient);
    return (react_1.default.createElement(stream_chat_react_1.Chat, { client: exports.chatClient, i18nInstance: i18n_1.streamI18n }, children));
};
exports.ChatManager = ChatManager;
